const Divider: React.FC<{className?: string}> = ({className}) => {
    return (
        <div className={`absolute top-0 left-0 w-full md:h-56 h-36 bg-gradient-to-l from-pink-700 via-slate-950 to-gray-700 ${className}`}/>
    );
}

export default Divider;
